import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const EnabledPopularItemText = styled(Typography)({
  fontSize: '16px',
  fontWeight: 400,
  color: 'rgba(146, 147, 152, 1)',
  maxWidth: '639px',
  marginBottom: '8px',
});